import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './components/Main';
import HimnarioPrivacyPolicyEn from './components/Himnario-PoliticaDePrivacidad-en';
import HimnarioPrivacyPolicyEs from './components/Himnario-PoliticaDePrivacidad-es';
import CoroAppPrivacyPolicyEs from './components/CoroApp-PoliticaDePrivacidad-es';
import NotFound404 from './components/NotFound404';
import MemoryMaster from './components/Games/MemoryMaster/MemoryMaster';
import PlatformGame from './components/Games/PlatformGame/PlatformGame';
import AdminPanel from './components/CoroApp/AdminPanel';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main route for the homepage */}
        <Route path="/" element={<Main />} />
        
        {/* Nested routes for Himnario app */}
        <Route path="himnario">
          <Route path="politica-de-privacidad-en" element={<HimnarioPrivacyPolicyEn />} />
          <Route path="politica-de-privacidad-es" element={<HimnarioPrivacyPolicyEs />} />
        </Route>

        <Route path="coroapp">
          <Route path="politica-de-privacidad-es" element={<CoroAppPrivacyPolicyEs />} />
          <Route path="admin-panel" element={<AdminPanel />} />
        </Route>

        <Route path="games">
          <Route path="memory-master" element={<MemoryMaster />} />
          <Route path="platform-game" element={<PlatformGame />} />
        </Route>
        
        {/* Catch-all route for 404 */}
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;